// extracted by mini-css-extract-plugin
export var barContainer = "_58-0";
export var extraThin = "_58-3";
export var fillBar = "_58-6";
export var fillContainer = "_58-4";
export var overflow = "_58-8";
export var overflowContainer = "_58-5";
export var regular = "_58-7";
export var thick = "_58-1";
export var thin = "_58-2";